import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import LogQrService from './Log-qr-service';
import BreadcrumbComponent from '../../../components/Breadcrumb';
import { Dropdown } from 'primereact/dropdown';

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
};

interface RecordFilter {
    [key: string]: string | boolean | Date; // Adjust types as needed
}

const LogQRList: React.FC = () => {
    const [gridDataSource, setGridDataSource] = useState<any[]>([]);
    const [modules, setModules] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const navigate = useNavigate();
    const [clientState, setClientState] = useState<any>(null);

    const [entityDropdown, setEntityDropdown] = useState<any[]>([]);
    const entityDropdownOptions = useMemo(() => entityDropdown, [entityDropdown]);

    const [recordFilter, setRecordFilter] = useState<RecordFilter>({
        snNo: '',
    });
    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await LogQrService.getClientState();
                setClientState(clientStateItem);


                LogQrService.getDropdown('AST', 'ENTITY').then((data) => {
                    setEntityDropdown(data);
                });

            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

    // useEffect(() => {
    //     if (clientState) {
    //         const fetchModuleList = async () => {
    //             try {
    //                 const response = await LogQrService.findAll(clientState.facilityCode);
    //                 setModules(response);
    //             } catch (error) {
    //                 console.error('Error fetching user data:', error);
    //             } finally {
    //                 setLoading(false);
    //             }
    //         };

    //         fetchModuleList();
    //     }
    // }, [clientState]);



    function handleCreate(): void {
        navigate(`/admin/module-edit`);
    }

    const handleEdit = (module: any) => {

        navigate('/admin/module-edit', {
            state: { module: module },
        });
    };

    const handleView = (module: any) => {

        navigate('/admin/module-view', {
            state: { module: module },
        });

    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters(defaultFilters);
        setGlobalFilterValue('');
    }

    const statusTemplate = (rowData: { recordStatus: string }) => {
        return rowData.recordStatus === '1' ? 'Active' : 'Inactive';
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                {/* <Button type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} /> */}
                <div>
                    {/* <InputIcon className="pi pi-search" /> */}
                    {/* <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" /> */}
                </div>
                <div>
                    {/* <Button icon="pi pi-print" severity="danger" style={{ marginRight: '.1em' }} onClick={() => handlePrint()} />
                    <Button label="New" icon="pi pi-plus" style={{ marginRight: '.5em' }} onClick={() => handleCreate()} /> */}
                </div>
            </div>
        );
    };

    const header = renderHeader();

    function handlePrint(): void {
        window.print();
    };

    const actionTemplate = (rowData: any) => (
        <div style={{ display: 'flex', gap: '5px' }}>
            <Button
                label="View"
                icon="pi pi-eye"
                className="p-button-info p-button-sm "
                style={{ padding: '5px 5px', fontSize: '10px' }}
                onClick={() => handleView(rowData)}
            />
            <Button
                label="Edit"
                icon="pi pi-pencil"
                className="p-button-warning p-button-sm "
                style={{ padding: '5px 5px', fontSize: '10px' }}
                onClick={() => handleEdit(rowData)}
            />
        </div>
    );
    
    const recordFilterTemplate = () => {
        const handleRecordFilterChange = (e: any) => {
            const { id, value } = e.target;
            setRecordFilter({
                ...recordFilter,
                [id]: value
            });

            console.log(recordFilter)
        };

        const resetFilter = () => {
            setRecordFilter({});
            setGridDataSource([]);
        };

        const search = () => {

            console.log(recordFilter)
            if (recordFilter) {
                LogQrService.findAllLog(recordFilter).then((data) => {
                    setGridDataSource(data);
                });
            }
        }

        return (
            <div className="p-fluid form-grid grid">
                <div className="flex gap-4">
                    <div className="f-field-md4">
                        <label className="f-label" htmlFor="entity">Entity</label>
                        <Dropdown
                            id="entity"
                            value={recordFilter?.entity}
                            onChange={handleRecordFilterChange}
                            options={entityDropdownOptions}
                            optionLabel="fullDesc"
                            optionValue="referenceCode"
                            placeholder="Select One"
                            showClear
                        />
                    </div>

                    <div className="f-field-md4">
                        <label className="f-label" htmlFor="snNo">Serial No</label>
                        <InputText
                            id="snNo"
                            value={(recordFilter.snNo as string) || ''}
                            onChange={handleRecordFilterChange}
                        />
                    </div>
                </div>
                <div className="col-12 flex align-items-end flex-row-reverse gap-2">
                    <div className='flex '>
                        <Button
                            label='Reset'
                            icon="pi pi-undo"
                            onClick={resetFilter}
                            severity='warning'
                        />
                    </div>
                    <div>
                        <Button
                            label='Search'
                            icon="pi pi-search"
                            onClick={search}
                            severity='info'
                        />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='grid'>
            <div className='col-12'>
                <div className='card-title'>
                    <h5>QR log List</h5>
                    <BreadcrumbComponent />
                </div>
                <div className='card'>
                    {/* <div className='filter-title'>
                        <h4>Search Criteria</h4>
                    </div> */}

                    <div className='filter-body'>
                        {recordFilterTemplate()}
                    </div>
                </div>
                <div className='card'>
                    <>
                        <DataTable value={gridDataSource}
                            showGridlines
                            scrollable
                            scrollHeight='auto'
                            paginator rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            filters={filters}
                            header={header}
                            sortField='modifiedDate'
                            sortOrder={-1}
                        >
                            <Column
                                header="No."
                                style={{ width: '5%' }}
                                body={(_, { rowIndex }) => rowIndex + 1} // Render row number
                                headerClassName="list-header"
                            ></Column>
                            <Column
                                field="snNo"
                                header="Serial No"
                                headerClassName="list-header"
                                body={(rowData) => rowData?.snNo ? rowData.snNo : '-'}
                            />

                            <Column
                                field="assignBy"
                                header="Assign By"
                                headerClassName="list-header"
                                body={(rowData) => rowData?.assignBy ? rowData.assignBy : '-'}
                            />

                            <Column
                                field="assignDate"
                                header="Assign Date"
                                headerClassName="list-header"
                                body={(rowData) =>
                                    rowData?.assignDate
                                        ? new Date(rowData.assignDate).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: true,
                                        })
                                        : '-'
                                }
                            />

                            <Column
                                field="unassignBy"
                                header="Unassigned By"
                                headerClassName="list-header"
                                body={(rowData) => rowData?.unassignBy ? rowData.unassignBy : '-'}
                            />

                            <Column
                                field="unassignDate"
                                header="Unassigned Date"
                                headerClassName="list-header"
                                body={(rowData) =>
                                    rowData?.unassignDate
                                        ? new Date(rowData.unassignDate).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: true,
                                        })
                                        : '-'
                                }
                            />

                            <Column
                                field="insertDate"
                                header="Register Date"
                                headerClassName="list-header"
                                body={(rowData) =>
                                    rowData?.insertDate
                                        ? new Date(rowData.insertDate).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: true,
                                        })
                                        : '-'
                                }
                            />
                        </DataTable>
                    </>
                </div>
            </div>
        </div>
    );
};

export default LogQRList;
